var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14286 0 0 3.14286 0 7C0 10.8571 3.14286 14 7 14C10.8571 14 14 10.8571 14 7C14 3.14286 10.8571 0 7 0ZM7.57141 9.49998C7.57141 9.78572 7.35714 10.0715 7 10.0715C6.64286 10.0715 6.42859 9.85712 6.42859 9.49998V6.64286C6.42859 6.35712 6.64286 6.07145 7 6.07145C7.35714 6.07145 7.57141 6.28572 7.57141 6.64286V9.49998ZM7 5.21429C6.64286 5.21429 6.28572 4.85715 6.28572 4.5C6.28572 4.14286 6.64286 3.78571 7 3.78571C7.35714 3.78571 7.71428 4.14286 7.71428 4.5C7.71428 4.85715 7.35714 5.21429 7 5.21429Z",
    fill: "#721C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.361ec346bdb89b7a866282ee275d439a.svg";
export { ForwardRef as ReactComponent };